import React from "react";
import { Card } from "antd";

const BUWiseCountTiles = ({ buWiseCount }) => {
  const nameMapping = {
    "Pallav Maheshwari": "Pallav M",
    "Vulugundam Anil Kumar": "Anil K",
    "Rajesh Dommaraju": "Rajesh D",
    "Umesh Balram": "Umesh B",
    "Yerradoddi Ravi Kumar Reddy": "Ravi R",
  };

  if (!buWiseCount || buWiseCount.length === 0) {
    return (
      <Card style={{ border: "1px solid #0000001F", borderRadius: "24px" }}>
        <div
          style={{
            fontWeight: "700",
            fontSize: "16px",
            padding: "8px",
            textAlign: "center",
          }}
        >
          No Data Available
        </div>
      </Card>
    );
  }

  return (
    <Card style={{ border: "1px solid #0000001F", borderRadius: "16px", padding: "0px 8px" }}>
      <div style={{ fontWeight: "700", fontSize: "16px", marginBottom: "6px" }}>
        BU Wise Count
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
          gap: "12px",
          marginBottom: "3px",
        }}
      >
        {buWiseCount.map((bu, index) => (
          <div
            key={index}
            style={{
              background: "#f0f5ff",
              padding: "8px",
              borderRadius: "8px",
              textAlign: "center",
              fontWeight: "600",
            }}
          >
            <div style={{ fontSize: "14px", color: "#555" }}>{bu.name}</div>
            <div style={{ fontSize: "18px", color: "#2989FF" }}>{bu.employeeCount || 0}</div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default BUWiseCountTiles;

